module.exports = __webpack_public_path__ + "img/1028.51336959.png";